import { Stack, styled } from '@mui/material'
import { PlaceOrderPostOnly } from 'components/PlaceOrderPostOnly'
import { PlaceOrderTIF } from 'components/PlaceOrderTIF'
import { memo } from 'react'
import { TradeType } from 'store/market/types'
import { OrderModeNames } from '../../../../store/spot/types'
import { useSpotSelectedOrderMode } from '../../../../store/spot/hooks'

const Wrap = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0;
  border-top: 1px solid ${(props) => props.theme.color.text10};
`

export const OrderProperties = memo(() => {
  const orderMode = useSpotSelectedOrderMode()

  // Post-Only and TIF is not available for market orders
  if (
    orderMode.name === OrderModeNames.Market ||
    orderMode.name === OrderModeNames.StopMarket
  ) {
    return <Wrap />
  }

  return (
    <Wrap id="zk_post_only">
      <PlaceOrderPostOnly tradeType={TradeType.Spot} />
      <PlaceOrderTIF tradeType={TradeType.Spot} />
    </Wrap>
  )
})
